<template>
    <div>
        <div class="hint block">
            <p>服务已关联：已设置本商户为默认服务商的客户机构</p>
            <p>全部：全部的客户机构</p>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="服务已关联" name="servcRel"></el-tab-pane>
            <el-tab-pane label="全部" name="all"></el-tab-pane>
        </el-tabs>
        <div v-show="activeName == 'servcRel'">
            <swb-retailer-shop-rel-servicer-list-for-select :ebChannel="ebChannel" :checkBox="checkBox" :filter="filter" :operation="operation" :action="action" :checkedIds="thisCheckedIds" :disableIds="disableIds" :isRetailerRel="isRetailerRel" @handle-change="handleChange" ref="swb_shop_rel_servicer_list_for_select"></swb-retailer-shop-rel-servicer-list-for-select>
        </div>
        <div v-show="activeName == 'all'">
            <swb-retailer-shop-list-for-select :ebChannel="ebChannel" :checkBox="checkBox" :filter="filter" :operation="operation" :action="action" :checkedIds="thisCheckedIds" :disableIds="disableIds" :isRetailerRel="isRetailerRel" @handle-change="handleChange" ref="swb_shop_list_for_select"></swb-retailer-shop-list-for-select>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import retailerApi from '../../api/retailer'

    import SwbRetailerShopListForSelect from './RetailerShopListForSelect'
    Vue.regist(SwbRetailerShopListForSelect);

    import SwbRetailerShopRelServicerListForSelect from './RetailerShopRelServicerListForSelect'
    Vue.regist(SwbRetailerShopRelServicerListForSelect);

    export default {
        name: 'swb-org-for-select',
        desc: '机构选择',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            disableIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            isRetailerRel: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                //
                activeName: "servcRel",
                // 网点策略事件总线
                ebChannel: 'shopStrategy',
                thisCheckedIds: [],
                operation: null,
                action: null
            }
        },
        created: function () {
            this.thisCheckedIds = Utils.merge([], this.checkedIds);
        },
        methods: {
            //
            handleClick(tab, event) {
            },
            handleChange: function (item) {
                let checkedIds = item.checkedIds || [];
                this.operation = item.operation;
                this.action = item.action;
                this.thisCheckedIds = Utils.merge([], checkedIds);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let relShopInfo = self.$refs['swb_shop_rel_servicer_list_for_select'].getDlgResult() || {};
                let shopInfo = self.$refs['swb_shop_list_for_select'].getDlgResult() || {};
                let retailerShopList = relShopInfo.data || [];
                let shopList = shopInfo.data || [];
                if(retailerShopList.length <= 0 && shopList.length <= 0) {
                    result.type = "warn";
                    result.message = "请至少选择一个机构";
                } else {
                    let retailerShopIds = [];
                    if(retailerShopList.length > 0) {
                        //
                        for(let i = 0; i < retailerShopList.length; i++) {
                            let retailerShop = retailerShopList[i];
                            let retailerShopId = retailerShop.id;
                            if(!retailerShopIds.contains(retailerShopId)) {
                                retailerShopIds.push(retailerShopId);
                            }
                        }
                        //
                        if(shopList.length > 0) {
                            for(let i = 0; i < shopList.length; i++) {
                                let shop = shopList[i];
                                let id = shop.id;
                                if(!retailerShopIds.contains(id)) {
                                    retailerShopIds.push(id);
                                }
                            }
                        }
                    }
                    result.type = "info";
                    result.data = retailerShopIds;
                }
                //
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/OrgForSelect.vue